import { render } from "./Lycra.vue?vue&type=template&id=fd798376&scoped=true"
import script from "./Lycra.vue?vue&type=script&lang=js"
export * from "./Lycra.vue?vue&type=script&lang=js"

import "./Lycra.vue?vue&type=style&index=0&id=fd798376&lang=scss&scoped=true"

import exportComponent from "C:\\Dev\\Vue\\intensione\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd798376"]])

export default __exports__